import React from "react";
import { Container, Col, Row, Table } from "react-bootstrap";
import Header from "../stories/components/Header.js";
import ColorTableRow from "../stories/components/ColorTableRow";
import ColorTableHead from "../stories/components/ColorTableHead";
import Image from "../stories/components/Image.js";
import ColorsAdobeTutorial from '../assets/colors/ColorsAdobeTutorial.png'

export default function ColorsPage() {
  return (
    <Container className="mb-6">
      <article>
        <Header
          title="Farger"
          lead="Fargene er valgt for å kunne ha noe varisjon i uttrykket i vår kommunikasjon samtidig som vi opprettholder vår formelle rolle. Hovedfarge er mørk blå. Signalfargene orange og rød skal benyttes som navnet tilsier."
        />
        <main>
          <Row className="my-6">
            <Col lg={{ span: 10, offset: 1 }}>
              <h2>Hovedfarge</h2>
              <Table responsive size="lg" className="table-simple">
                <ColorTableHead />
                <tbody>
                  <ColorTableRow
                    colorCode="#00244E"
                    textColor="#ffffff"
                    colorName="Mørk blå"
                    hex="#00244E"
                    rgb="(000,036,078)"
                    cmyk="100/70/0/65"
                    pms="295 C"
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col lg={{ span: 10, offset: 1 }}>
              <h2>Støttefarger</h2>
              <Table responsive size="lg" className="table-simple">
                <ColorTableHead />
                <tbody>
                  <ColorTableRow
                    colorCode="#000000"
                    textColor="#ffffff"
                    colorName="Svart"
                    hex="#000000"
                    rgb="(000,000,000)"
                    cmyk="60/0/0/100"
                    pms="Black C"
                  />
                  <ColorTableRow
                    colorCode="#43545F"
                    textColor="#ffffff"
                    colorName="75 %"
                    hex="#43545F"
                    rgb="(067,084,095)"
                    cmyk="45/0/0/75"
                  />

                  <ColorTableRow
                    colorCode="#7B8C98"
                    textColor="#ffffff"
                    colorName="50%"
                    hex="#7B8C98"
                    rgb="(123,140,152)"
                    cmyk="30/0/0/50"
                  />
                  <ColorTableRow
                    colorCode="#BAC4CD"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#BAC4CD"
                    rgb="(186,196,205)"
                    cmyk="15/0/0/25"
                  />
                  <div className="mb-5" />
                  <ColorTableRow
                    colorCode="#00244E"
                    textColor="#ffffff"
                    colorName="Mørk blå"
                    hex="#00244E"
                    rgb="(000,036,078)"
                    cmyk="100/70/0/65"
                    pms="295 C"
                  />
                  <ColorTableRow
                    colorCode="#3C4A71"
                    textColor="#ffffff"
                    colorName="75 %"
                    hex="#3C4A71"
                    rgb="(060,074,113)"
                    cmyk="75/52/0/49"
                  />
                  <ColorTableRow
                    colorCode="#71799D"
                    textColor="#ffffff"
                    colorName="50 %"
                    hex="#71799D"
                    rgb="(113,121,157)"
                    cmyk="50/35/0/32"
                  />
                  <ColorTableRow
                    colorCode="#B1B6CD"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#B1B6CD"
                    rgb="(177,182,205)"
                    cmyk="25/17/0/16"
                  />
                  <div className="mb-5" />
                  <ColorTableRow
                    colorCode="#4C76BA"
                    textColor="#ffffff"
                    colorName="Lys blå"
                    hex="#4C76BA"
                    rgb="(076,118,186)"
                    cmyk="75/50/0/0"
                    pms="285 C"
                  />
                  <ColorTableRow
                    colorCode="#8595CA"
                    textColor="#ffffff"
                    colorName="75 %"
                    hex="#8595CA"
                    rgb="(133,149,202)"
                    cmyk="56/37/0/0"
                  />
                  <ColorTableRow
                    colorCode="#AEB6DC"
                    textColor="#00244E"
                    colorName="50 %"
                    hex="#AEB6DC"
                    rgb="(174,182,220)"
                    cmyk="37/25/0/0"
                  />
                  <ColorTableRow
                    colorCode="#D6DAEF"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#D6DAEF"
                    rgb="(214,218,239)"
                    cmyk="19/12/0/0"
                  />
                  <div className="mb-5" />
                  <ColorTableRow
                    colorCode="#00ADBA"
                    textColor="#ffffff"
                    colorName="Turkis"
                    hex="#00ADBA"
                    rgb="(000,173,186)"
                    cmyk="80/0/35/0"
                    pms="7466 C"
                  />
                  <ColorTableRow
                    colorCode="#87C0C4"
                    textColor="#00244E"
                    colorName="75 %"
                    hex="#87C0C4"
                    rgb="(135,192,196)"
                    cmyk="60/0/26/0"
                  />
                  <ColorTableRow
                    colorCode="#B3D6D9"
                    textColor="#00244E"
                    colorName="50 %"
                    hex="#B3D6D9"
                    rgb="(179,214,217)"
                    cmyk="40/0/15/0"
                  />
                  <ColorTableRow
                    colorCode="#DBEBEC"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#DBEBEC"
                    rgb="(219,235,236)"
                    cmyk="20/0/9/0"
                  />
                  <div className="mb-5" />
                  <ColorTableRow
                    colorCode="#BFC2C0"
                    textColor="#00244E"
                    colorName="Grå"
                    hex="#BFC2C0"
                    rgb="(191,194,192)"
                    cmyk="5/0/5/30"
                    pms="Cool gray 5"
                  />
                  <ColorTableRow
                    colorCode="#CFD1CF"
                    textColor="#00244E"
                    colorName="75 %"
                    hex="#CFD1CF"
                    rgb="(207,209,207)"
                    cmyk="3,75/0/3,75/22,5"
                  />
                  <ColorTableRow
                    colorCode="#DFE0DF"
                    textColor="#00244E"
                    colorName="50 %"
                    hex="#DFE0DF"
                    rgb="(223,224,223)"
                    cmyk="2,5/0/2,5/15"
                  />
                  <ColorTableRow
                    colorCode="#EFF0EF"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#EFF0EF"
                    rgb="(239,240,239)"
                    cmyk="1,25/0/1,25/7,5"
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="my-6">
            <Col lg={{ span: 10, offset: 1 }}>
              <h2>Signalfarger</h2>
              <p>
                Signalfargene orange og rød skal benyttes som navnet tilsier
              </p>
              <Table responsive size="lg" className="table-simple">
                <ColorTableHead />
                <tbody>
                  <ColorTableRow
                    colorCode="#F39200"
                    textColor="#ffffff"
                    colorName="Orange"
                    hex="#F39200"
                    rgb="(243,146,000)"
                    cmyk="0/50/100/0"
                    pms="144 C"
                  />
                  <ColorTableRow
                    colorCode="#E6AE56"
                    textColor="#00244E"
                    colorName="75 %"
                    hex="#E6AE56"
                    rgb="(230,174,086)"
                    cmyk="0/37/75/0"
                  />

                  <ColorTableRow
                    colorCode="#EFCA8F"
                    textColor="#00244E"
                    colorName="50%"
                    hex="#EFCA8F"
                    rgb="(239,202,143)"
                    cmyk="0/25/50/0"
                  />
                  <ColorTableRow
                    colorCode="#F7E5C8"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#F7E5C8"
                    rgb="(247,229,200)"
                    cmyk="0/12/25/0"
                  />
                  <div className="mb-5" />
                  <ColorTableRow
                    colorCode="#C90B1C"
                    textColor="#ffffff"
                    colorName="Rød"
                    hex="#C90B1C"
                    rgb="(201,011,028)"
                    cmyk="0/100/90/15"
                    pms="186 C"
                  />
                  <ColorTableRow
                    colorCode="#BD5749"
                    textColor="#ffffff"
                    colorName="75 %"
                    hex="#BD5749"
                    rgb="(189,087,073)"
                    cmyk="0/75/67/11"
                  />
                  <ColorTableRow
                    colorCode="#D1917C"
                    textColor="#ffffff"
                    colorName="50 %"
                    hex="#D1917C"
                    rgb="(209,145,124)"
                    cmyk="0/50/45/7,5"
                  />
                  <ColorTableRow
                    colorCode="#E8C9BC"
                    textColor="#00244E"
                    colorName="25 %"
                    hex="#E8C9BC"
                    rgb="(232,201,188)"
                    cmyk="0/25/22/3,75"
                  />
                </tbody>
              </Table>
            </Col>
          </Row>
          <Row className="content">
            <Col md={{ span: 8, offset: 2 }}>
              <h3>Last inn paletten i Adobe:</h3>
            <p>Vi har laget en ase-fil av fargepaletten, som gjør at du kan laste den inn i ulike Adobe-program.
                ASE-filen har navnet: Farger statsforvalteren.ase
                Du finner den her: \\fylkesmannen. local\sf\Maler\SF
                Slik laster du den inn i Adobe InDesign og PhotoShop:
            </p>
            <ol>
              <li>Klikk på høyremenyen i «farger»/«swatches»</li>
              <li>Velg «Last inn fargeprøver»</li>
              <li>I åpne fil vinduet - skriv inn: \\fylkesmannen.local\sf\malser\sf\farger statsforvalteren.ase</li>
              <li>Velg åpne, og du har lastet inn fargepaletten</li>
            </ol>
            </Col>
          </Row>
          <Image
            size="small"
            imgUrl={ColorsAdobeTutorial}
            alt="Konvolutter i ulike størrelser og format."
          />   
        </main>
      </article>
    </Container>
  );
}
